var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavDollarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.27,
    height: 27,
    viewBox: "0 0 15.27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-attach-money",
    "data-name": "Icon material-attach-money",
    d: "M17.7,16.35c-3.4-.885-4.5-1.8-4.5-3.225,0-1.635,1.515-2.775,4.05-2.775,2.67,0,3.66,1.275,3.75,3.15h3.315A5.979,5.979,0,0,0,19.5,7.785V4.5H15V7.74c-2.91.63-5.25,2.52-5.25,5.415,0,3.465,2.865,5.19,7.05,6.2,3.75.9,4.5,2.22,4.5,3.615,0,1.035-.735,2.685-4.05,2.685-3.09,0-4.305-1.38-4.47-3.15H9.48c.18,3.285,2.64,5.13,5.52,5.745V31.5h4.5V28.275c2.925-.555,5.25-2.25,5.25-5.325C24.75,18.69,21.1,17.235,17.7,16.35Z",
    transform: "translate(-9.48 -4.5)",
    fill: "#2cccd3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDollarIcon);
export default __webpack_public_path__ + "static/media/nav-dollar-icon.e00a5e2e.svg";
export { ForwardRef as ReactComponent };